import React, { act, useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { TbFileExport } from "react-icons/tb";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { IoEyeOutline } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import { TbCubePlus } from "react-icons/tb";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { MdDeleteOutline } from "react-icons/md";

import "./Inventory.css";
import "../Dashboard/Dashboard.css";
import productImg from "../../../assets/images/State-Distributor/inventoryProduct.png";
import placeholderImg from "../../../assets/images/previewPlaceholder.png";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik, useFormik } from "formik";
import TablePagination from "@mui/material/TablePagination";
import { IoClose } from "react-icons/io5";
import { GoSearch } from "react-icons/go";
import * as yup from "yup";
import { AiOutlineDelete } from "react-icons/ai";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

let addProductSchema = yup.object({
  // product_image: yup.string().required("Product image is required"),
  default_cost_price: yup.number().required("Default cost price is required"),
  // subdistributor_selling_price: yup
  //   .number()
  //   .required("Subdistributor price is required"),
  retail_selling_price: yup
    .number()
    .required("Retail selling price is required"),
});

function createData2(
  productName,
  productCode,
  category,

  avl,
  minStock,

  actions,
) {
  return {
    productName,
    productCode,
    category,

    avl,
    minStock,

    actions,
  };
}

const rows2 = [
  createData2("Premium Interior Emul.", "PNT-001", "Emulsion", "40", "50"),
  createData2("Premium Interior Emul.", "PNT-001", "Emulsion", "40", "50"),
  createData2("Premium Interior Emul.", "PNT-001", "Emulsion", "40", "50"),
];

export const SubInventory = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [activeMenu, setactiveMenu] = useState("allProducts");
  const [allProducts, setAllProducts] = useState({});

  const [refNo, setRefNo] = useState();
  const [receivedData, setReceivedData] = useState();
  const [paymentType, setPaymentType] = useState();
  const [paymentMode, setPaymentMode] = useState();

  const [additionalNote, setAdditionalNote] = useState();
  const [productDetails, setProductDetails] = useState({});
  // const[productCode,setProductCode]=useState();

  function handleSelectMenu(menu) {
    setactiveMenu(menu);
  }
  //   reorder modal
  const [reordershow, setReorderShow] = useState(false);

  const handleReorderClose = () => setReorderShow(false);
  const handleReorderShow = (productId) => {
    setReorderShow(true);
    fetchProductDetails(productId);
  };

  // add product modal
  const [addshow, setAddShow] = useState(false);

  const handleAddClose = () => setAddShow(false);
  const handleAddShow = () => setAddShow(true);

  const formik = useFormik({
    initialValues: {
      // product_image: null,
      // product_name: "",
      product_code: "",
      // category: "",
      // uom: "",
      default_cost_price: "",
      // subdistributor_selling_price: "",
      retail_selling_price: "",
      min_stock_level: "",
      // isi_code: "",
      // package_size: "",
      // hs_code: "",
      // additional_notes: "",
    },
    validationSchema: addProductSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const formData = new FormData();
        // formData.append("product_image", values.product_image);
        // formData.append("product_name", values.product_name);
        formData.append("product_code", values.product_code);
        // formData.append("category", values.category);
        // formData.append("uom", values.uom);
        formData.append("default_cost_price", values.default_cost_price);
        // formData.append(
        //   "subdistributor_selling_price",
        //   values.subdistributor_selling_price
        // );
        formData.append("retail_selling_price", values.retail_selling_price);
        formData.append("min_stock_level", values.min_stock_level);
        // formData.append("isi_code", values.isi_code);
        // formData.append("package_size", values.package_size);
        // formData.append("hs_code", values.hs_code);
        // formData.append("additional_notes", values.additional_notes);

        const response = await axiosInstance.post(
          "inventory/subdistributor/product-create/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        if (response.data.status === "Success" || response.status === 200) {
          toast.success(response.data.message || "Product addded successfully");
          FetchAllProducts();
          resetForm();
          handleAddClose();
        }
      } catch (error) {
        toast.error("Failed to add product");
        console.log("Failed to add product");
      } finally {
        setLoading(false);
      }
    },
  });

  const [dropdownProductcode, setDropdownProductCode] = useState();

  async function LoadDropdownProductcode() {
    try {
      const response = await axiosInstance.get(
        "/inventory/distributor/product-code/",
      );
      if (response.data.status === "success" || response.status === 200) {
        setDropdownProductCode(response.data.data);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to load dropdown");
      console.log("Failed to load dropdown");
    }
  }
  useEffect(() => {
    LoadDropdownProductcode();
  }, []);

  const [allPage, setAllPage] = useState(0);
  const [allRowsPerPage, setAllRowsPerPage] = useState(5);
  const [allTotalCount, setAllTotalCount] = useState(0);

  const handleAllRowsPerPage = (event) => {
    setAllRowsPerPage(+event.target.value);
    setAllPage(0);
  };

  // Filters
  const [searchText, setSearchText] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [selectedLabel, setSelectedLabel] = useState("");
  const [show, setShow] = useState(false);
  const [categoryToggler, setCategoryToggler] = useState("");

  async function FetchAllProducts() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: allPage + 1,
          page_size: allRowsPerPage,
          search: searchText,
          category: categoryToggler,
          date: selectedLabel,
          sort_by: sortBy,
        },
      };
      const response = await axiosInstance.get(
        "inventory/subdistributor/product-list/",
        config,
      );
      if (response.data.status === "success" || response.status === 200) {
        setAllProducts(response.data?.data);
        setAllTotalCount(response.data?.data.count);
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch all products",
      );
      console.log("Failed to fetch all products");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    FetchAllProducts();
  }, [allPage, allRowsPerPage]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (allPage !== 0) {
        setAllPage(0);
      } else {
        FetchAllProducts();
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchText, categoryToggler, selectedLabel, sortBy]);

  const [lowPage, setLowPage] = useState(0);
  const [lowRowsPerPage, setLowRowsPerPage] = useState(5);
  const [lowTotalCount, setLowTotalCount] = useState(0);

  const handleLowRowsPerPage = (event) => {
    setLowRowsPerPage(+event.target.value);
    setLowPage(0);
  };
  const [lowStockDetails, setLowStockDetails] = useState({});

  async function FetchLowStockDetails() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: lowPage + 1,
          page_size: lowRowsPerPage,
          search: searchText,
          category: categoryToggler,
          date: selectedLabel,
          sort_by: sortBy,
        },
      };
      const response = await axiosInstance.get(
        "/inventory/subdistributor/low-stock/",
        config,
      );
      if (response.data.status === "Success" || response.status === 200) {
        setLowStockDetails(response.data.data);
        setLowTotalCount(response.data?.data.count);
        console.log("Low stock details fetched successfully");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch low stock details",
      );
      console.log("Failed to fetch low stock details");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    FetchLowStockDetails();
  }, [lowPage, lowRowsPerPage]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (lowPage !== 0) {
        setLowPage(0);
      } else {
        FetchLowStockDetails();
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchText, categoryToggler, selectedLabel, sortBy]);

  const [historyPage, setHistoryPage] = useState(0);
  const [historyRowsPerPage, setHistoryRowsPerPage] = useState(5);
  const [historyTotalCount, setHistoryTotalCount] = useState(0);

  const handleHistoryRowsPerPage = (event) => {
    setHistoryRowsPerPage(+event.target.value);
    setHistoryPage(0);
  };

  const [stockHistoryData, setStockHistoryData] = useState([]);
  async function FetchStockHistory() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: historyPage + 1, // backend expects 1-based index
          page_size: historyRowsPerPage,
          search: searchText,
          category: categoryToggler,
          date: selectedLabel,
          sort_by: sortBy,
        },
      };
      const response = await axiosInstance.get(
        "/inventory/subdistributor/stock-history/",
        config,
      );
      if (response.data.status === "Success" || response.data.status === 200) {
        setStockHistoryData(response.data.data);
        setHistoryTotalCount(response.data?.data.count);
        console.log("Stock history fetched successfully");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch stock histroy",
      );
      console.log("Failed to fetch stock histroy");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    FetchStockHistory();
  }, [historyPage, historyRowsPerPage]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (historyPage !== 0) {
        setHistoryPage(0);
      } else {
        FetchStockHistory();
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchText, categoryToggler, selectedLabel, sortBy]);

  //Clear filters
  function handleClearFilters() {
    setSearchText("");
    setCategoryToggler("");
    setSelectedLabel("");
    setSortBy("");
  }

  // reset search
  function handleReset() {
    setSearchText("");
  }

  async function fetchProductDetails(productId) {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/inventory/subdistributor/product/${productId}`,
      );
      if (response.data.status === "success" || response.status === 200) {
        setProductDetails(response.data.data);

        console.log(
          response.data.message || "Product details fetched successfully",
        );
        // toast.success(
        //   response.data.message || "Product details fetched successfully"
        // );
      }
    } catch (error) {
      console.log("Failed to fetch product details", error);
      toast.error(
        error.response?.data?.message || "Failed to fetch product details",
      );
    } finally {
      setLoading(false);
    }
  }
  // useEffect(() => {
  //   fetchProductDetails(productCode);
  // }, []);
  const [total, setTotal] = useState();
  const [qty, setQty] = useState(); // to display in Total Products Received
  function handleQtyChange(value, sellingPrice) {
    const qtyValue = Number(value);
    setQty(qtyValue);
    setTotal(qtyValue * Number(sellingPrice || 0));
  }

  async function handleSave() {
    try {
      setLoading(true);

      const payload = {
        reference_no: refNo?.trim() || "",
        received_date: receivedData,
        payment_type: paymentType,
        payment_mode: paymentMode,
        additional_notes: additionalNote,
        products: [
          {
            product_id: productDetails.id,
            qty: qty,
            // unit_cost_price: productDetails.default_cost_price || 0,
            total: total,
            price: productDetails.default_cost_price,
          },
        ],
      };
      console.log("payload", payload);
      const response = await axiosInstance.post(
        "inventory/subdistributor/reorder/",
        payload,
      );
      if (response.data.status === "Success" || response.status === 200) {
        setRefNo("");
        setReceivedData("");
        setAdditionalNote("");
        setQty("");
        setTotal("");
        handleReorderClose();
        toast.success(response.data.message || "submitted successfully");
        console.log("submitted successfully");
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to submit");
      console.log("Failed to submit");
    } finally {
      setLoading(false);
    }
  }
  const [categoryDropdown, setCategoryDropdown] = useState([]);

  async function LoadCategoryDropdown() {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/inventory/category/");
      if (response.data.status === "Success" || response.status === 200) {
        setCategoryDropdown(response.data.data);
        console.log("category dropdown fetched successfully");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch category dropdown",
      );
      console.log("Failed to fetch category dropdown");
    }
  }
  useEffect(() => {
    LoadCategoryDropdown();
  }, []);
  // stock history delete modal
  const [deleteStockHistoryId, setDeleteStockHistoryId] = useState();
  const [deleteStockHistoryshow, setDeleteStockHistoryShow] = useState(false);

  const handleDeleteStockHistoryClose = () => setDeleteStockHistoryShow(false);
  const handleDeleteStockHistoryShow = (id) => {
    setDeleteStockHistoryShow(true);
    setDeleteStockHistoryId(id);
  };

  async function handleDeleteStockHistory() {
    try {
      setLoading(true);
      const response = await axiosInstance.delete(
        `/inventory/subdistributor/incoming-stock-item-single-update/${deleteStockHistoryId}/`,
      );
      if (response.data.status === "Success" || response.status === 200) {
        toast.success(response.data.message || "Deleted successfully");
        console.log("Deleted successfully");
        handleDeleteStockHistoryClose();
        FetchStockHistory();
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to delete");
      console.log("Failed to delete");
    } finally {
      setLoading(false);
    }
  }

  // ref wise table
  const [refTableData, setRefTableData] = useState([]);
  const [refTablePage, setRefTablePage] = useState(() => {
    const savedPage = sessionStorage.getItem("sub_ref_page");
    return savedPage ? Number(savedPage) : 0;
  });
  const [refTableRowsPerPage, setRefTableRowsPerPage] = useState(() => {
    const savedRows = sessionStorage.getItem("sub_ref_rowsPerPage");
    return savedRows ? Number(savedRows) : 5;
  });
  const [refTableTotalCount, setRefTableTotalCount] = useState(0);
  const [refDateFilter, setRefDateFilter] = useState("");

  const handleRefTableRowsPerPage = (event) => {
    setRefTableRowsPerPage(+event.target.value);
    setRefTablePage(0);
    sessionStorage.setItem("sub_ref_rowsPerPage", +event.target.value);
    sessionStorage.setItem("sub_ref_page", 0);
  };

  async function FetchRefwiseProducts() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: refTablePage + 1,
          page_size: refTableRowsPerPage,
          date: refDateFilter,
        },
      };
      const response = await axiosInstance.get(
        "/inventory/distributor/incoming-stock-list/",
        config,
      );
      if (response.data.status === "success" || response.status === 200) {
        setRefTableData(response.data.data);
        setRefTableTotalCount(response.data?.data.count);
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch Added Stock products",
      );
      console.log("Failed to fetch Low Stock products");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      FetchRefwiseProducts();
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [refTablePage, refTableRowsPerPage, refDateFilter]);

  function handleClearRefFilters() {
    setRefDateFilter("");
    FetchRefwiseProducts();
  }

  // ref wise stock delete modal state
  const [deleteStockId, setDeleteStockId] = useState();
  const [deleteStockshow, setDeleteStockShow] = useState(false);

  const handleDeleteStockClose = () => setDeleteStockShow(false);
  const handleDeleteStockShow = (id) => {
    setDeleteStockShow(true);
    setDeleteStockId(id);
  };
  async function handleDeleteRefStock() {
    try {
      setLoading(true);
      const response = await axiosInstance.delete(
        `/inventory/subdistributor/incoming-stock-update/${deleteStockId}/`,
      );
      if (response.data.status === "Success" || response.status === 200) {
        toast.success(response.data.message || "Deleted successfully");
        console.log("Deleted successfully");
        handleDeleteStockClose();
        FetchRefwiseProducts();
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to delete");
      console.log("Failed to delete");
    } finally {
      setLoading(false);
    }
  }

  // in stock history edit modal
  const [inStockEditId, setInStockEditId] = useState("");
  const [instockeditshow, setInstockEditShow] = useState(false);

  const handleInstockEditClose = () => setInstockEditShow(false);
  const handleInstockEditShow = (id, existingQty) => {
    setInstockEditShow(true);
    setInStockEditId(id);
    setInStockQty(existingQty);
  };
  const [instockQty, setInStockQty] = useState("");
  async function handleInStockEdit() {
    try {
      setLoading(true);
      const payload = {
        qty: instockQty,
      };
      const response = await axiosInstance.put(
        `/inventory/subdistributor/incoming-stock-item-single-update/${inStockEditId}/`,
        payload,
      );
      if (response.data.status === "Success" || response.status === 200) {
        toast.success(response.data.message || "Updated successfully!");
        handleInstockEditClose();
        FetchStockHistory();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to update");
      console.log("Failed to update");
    } finally {
      setLoading(false);
    }
  }

  async function handleExport() {
    try {
      setLoading(true);

      let url = "";
      let defaultFileName = "export.xlsx";

      if (activeMenu === "allProducts") {
        url = "/inventory/subdistributor/product-list-excel/";
        defaultFileName = "all_products.xlsx";
      } else if (activeMenu === "low") {
        url = "/inventory/subdistributor/low-stock-excel/";
        defaultFileName = "low_stock.xlsx";
      } else if (activeMenu === "history") {
        url = "/inventory/subdistributor/stock-history-excel/";
        defaultFileName = "stock_history.xlsx";
      } else {
        return;
      }

      const response = await axiosInstance.get(url, {
        responseType: "blob",
      });

      if (response.status === 200) {
        // const blob = new Blob([response.data], { type: "application/pdf" });
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        // Try server-provided filename
        // const contentDisposition = response.headers["content-disposition"];
        // let fileName = "invoice.pdf";
        // // let fileName;
        // if (contentDisposition) {
        //   const match = contentDisposition.match(/filename="?(.+)"?/);
        //   if (match && match[1]) fileName = match[1];
        // }

        const contentDisposition = response.headers["content-disposition"];
        let fileName = defaultFileName;

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+)"?/);
          if (match && match[1]) {
            fileName = match[1].endsWith(".xlsx")
              ? match[1]
              : `${match[1]}.xlsx`;
          }
        }

        // Trigger download
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      let errorMessage = "Failed to export";

      if (error.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const json = JSON.parse(text);
          errorMessage = json.message || errorMessage;
        } catch (e) {
          // fallback if parsing fails
        }
      } else {
        errorMessage = error.response?.data?.message || errorMessage;
      }

      toast.error(errorMessage);
      console.error("Export failed", error);
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="inventoryContainer">
        <div className="container">
          <div className="dashboardTitleContainer">
            <div>
              <div className="inventoryTitle">Inventory</div>
              <div className="inventorySubtitle">
                Track available paint stock, reorder from your distributor, and
                manage low-stock alerts.
              </div>
            </div>
            <div className="addButtonContainer">
              <div className="inventoryBtnNewOrder">
                {/* <button onClick={handleAddShow}>Add Product</button> */}
                <button onClick={() => navigate("/sub-add-product")}>
                  Add Product
                </button>
              </div>
              {/* <div className="inventoryBtnReorder">
                <button onClick={() => navigate("/sub-inventory-reorder")}>
                  Re-Order
                </button>
              </div> */}

              <div className="inventoryBtnIncome">
                <button
                  onClick={() => navigate("/sub-inventory-addincomestock")}
                >
                  Add Incoming Stock
                </button>
              </div>
            </div>
          </div>
          <div className="searchMainContainer">
            <div className="searchSubContainer">
              <div className="searchGrid">
                <div>
                  <input
                    type="text"
                    placeholder="Search by Product Code, Product Name"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
                <div style={{ display: "flex", gap: "5px" }}>
                  <div>
                    <GoSearch className="searchIcon" />
                  </div>
                  <div className="btnRestSearch">
                    <button onClick={handleReset}>Reset</button>
                  </div>
                </div>
              </div>
              <div>
                <div className="dropdownTitle">Product Category</div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {categoryToggler || "All"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setCategoryToggler("All")}>
                      All
                    </Dropdown.Item>
                    {categoryDropdown?.map((cat) => (
                      <Dropdown.Item
                        onClick={() => setCategoryToggler(cat.name)}
                      >
                        {cat.name}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div>
                <div className="dropdownTitle">Date Range</div>
                <Dropdown show={show} onToggle={() => setShow(!show)}>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {selectedLabel || "Select"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu customDateMenu">
                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("7");
                      }}
                    >
                      Last 7 days
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("15");
                      }}
                    >
                      Last 15 days
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("30");
                      }}
                    >
                      Last 30 days
                    </Dropdown.Item>

                    <Dropdown.Item disabled>Custom Date :</Dropdown.Item>

                    <Dropdown.Item
                      as="div"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <input
                        type="date"
                        className="form-control"
                        onChange={(e) => {
                          setShow(false); // close after selecting
                          setSelectedLabel(e.target.value);
                        }}
                      />
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>

          {(searchText || categoryToggler || selectedLabel || sortBy) && (
            <div className="filterResultsContainer">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of
                </span>

                {searchText && (
                  <>
                    {" "}
                    , <strong>Search:</strong> {searchText}
                  </>
                )}
                {categoryToggler && categoryToggler !== "All" && (
                  <>
                    {" "}
                    , <strong>Category:</strong> {categoryToggler}
                  </>
                )}
                {selectedLabel && (
                  <>
                    {" "}
                    , <strong>Date:</strong> {selectedLabel}
                  </>
                )}
                {sortBy && (
                  <>
                    {" "}
                    , <strong>Sort By:</strong> {sortBy}
                  </>
                )}
              </div>

              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearFilters}
              >
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )}

          {/* cards section  */}
          <div className="inventoryCardsGrid">
            <div className="inventoryCard">
              <div>Total Stock Quantity</div>
              <div>{allProducts?.product_card?.total_stock_quantity}</div>
            </div>
            <div className="inventoryCard">
              <div>Total Stock Value (₹)</div>
              <div>{allProducts?.product_card?.total_stock_value}</div>
            </div>
            <div className="inventoryCard">
              <div>Low Stock Products</div>
              <div>{allProducts?.product_card?.low_stock_count}</div>
            </div>
            {(activeMenu === "allProducts" || activeMenu === "history") && (
              <div className="inventoryCard">
                <div>Near Expiry Batches</div>
                <div>---</div>
              </div>
            )}
          </div>
          {/* table menu  */}
          <div className="inventoryFilterContainer">
            <div className="inventoryMenu">
              <div
                onClick={() => handleSelectMenu("allProducts")}
                className={`menuTitle ${
                  activeMenu === "allProducts" ? "active" : ""
                }`}
              >
                All Products
              </div>
              <div
                onClick={() => handleSelectMenu("low")}
                className={`menuTitle ${activeMenu === "low" ? "active" : ""}`}
              >
                Low Stock
              </div>
              <div
                onClick={() => handleSelectMenu("history")}
                className={`menuTitle ${
                  activeMenu === "history" ? "active" : ""
                }`}
              >
                Stock History
              </div>
            </div>
            <div className="inventoryFilters">
              <div className="inventoryBtnExport">
                <button onClick={handleExport}>
                  Export{" "}
                  <span>
                    <TbFileExport />
                  </span>
                </button>
              </div>
              <div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    Sort by
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setSortBy("avl_qty")}>
                      Available Quantity
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => setSortBy("last_import")}>
                      Last Import
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => setSortBy("stock_value")}>
                      Stock Value
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
          {activeMenu === "allProducts" && (
            <div className="dashboardTableContainer">
              <TableContainer component={Paper}>
                <Table
                  // sx={{ minWidth: 650 }}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead className="dashboadTableHeader">
                    <TableRow>
                      <TableCell align="left">Product Image</TableCell>
                      <TableCell align="left">Product Name</TableCell>
                      <TableCell align="left">Product Code</TableCell>
                      <TableCell align="left">Category</TableCell>
                      <TableCell align="left">UOM</TableCell>
                      <TableCell align="left">Avl. Qty</TableCell>
                      <TableCell align="left">Last Import</TableCell>

                      <TableCell align="left">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {allProducts?.results?.length > 0 ? (
                      allProducts?.results?.map((row) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          className="dashboardTableBody"
                        >
                          <TableCell align="left">
                            <span className="productImg">
                              <img
                                src={
                                  row.product_image
                                    ? row.product_image
                                    : placeholderImg
                                }
                              />
                            </span>
                          </TableCell>
                          <TableCell align="left">{row.product_name}</TableCell>
                          <TableCell align="left">{row.product_code}</TableCell>
                          <TableCell align="left">{row.category}</TableCell>
                          <TableCell align="left">{row.uom}</TableCell>
                          <TableCell align="left">
                            {row.current_stock}
                          </TableCell>
                          <TableCell align="left">{row.last_import}</TableCell>

                          <TableCell align="left">
                            <button
                              className="btnTableView"
                              onClick={() => {
                                handleReorderShow(row.id);
                              }}
                            >
                              Re-Order
                            </button>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={8}
                          align="center"
                          style={{ padding: "20px" }}
                        >
                          Data not available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={allTotalCount}
                page={allPage}
                onPageChange={(event, newPage) => setAllPage(newPage)}
                rowsPerPage={allRowsPerPage}
                onRowsPerPageChange={handleAllRowsPerPage}
                rowsPerPageOptions={[5, 10, 20, 50]}
              />
            </div>
          )}
          {activeMenu === "low" && (
            <div className="dashboardTableContainer">
              <TableContainer component={Paper}>
                <Table
                  // sx={{ minWidth: 650 }}

                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead className="dashboadTableHeader">
                    <TableRow>
                      <TableCell align="left">Product Image</TableCell>
                      <TableCell align="left">Product Name</TableCell>
                      <TableCell align="left">Product Code</TableCell>
                      <TableCell align="left">Category</TableCell>
                      <TableCell align="left">Avl. Stock</TableCell>
                      <TableCell align="left">Min. Stock Level</TableCell>

                      <TableCell align="left">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {lowStockDetails?.results?.length > 0 ? (
                      lowStockDetails.results.map((row) => (
                        <TableRow
                          key={row.name}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          className="dashboardTableBody"
                        >
                          <TableCell align="left">
                            <span className="productImg">
                              <img
                                src={row.product_image || productImg}
                                alt=""
                              />
                            </span>
                          </TableCell>
                          <TableCell>{row.product}</TableCell>
                          <TableCell align="left">{row.product_code}</TableCell>
                          <TableCell align="left">{row.category}</TableCell>
                          <TableCell align="left">
                            {row.current_stock}
                          </TableCell>
                          <TableCell align="left">
                            {row.min_stock_level}
                          </TableCell>

                          <TableCell align="left">
                            <button
                              className="btnTableView"
                              onClick={() => {
                                handleReorderShow(row.id);
                              }}
                            >
                              Re-Order
                            </button>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={8}
                          align="center"
                          style={{ padding: "20px" }}
                        >
                          Data not available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={lowTotalCount}
                page={lowPage}
                onPageChange={(event, newPage) => setLowPage(newPage)}
                rowsPerPage={lowRowsPerPage}
                onRowsPerPageChange={handleLowRowsPerPage}
                rowsPerPageOptions={[5, 10, 20, 50]}
              />
            </div>
          )}

          {activeMenu === "history" && (
            <div className="dashboardTableContainer">
              <TableContainer component={Paper}>
                <Table
                  // sx={{ minWidth: 650 }}

                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead className="dashboadTableHeader">
                    <TableRow>
                      <TableCell align="left">Date</TableCell>
                      <TableCell align="left">Product Image</TableCell>
                      <TableCell align="left">Product Name</TableCell>
                      <TableCell align="left">Change Type</TableCell>
                      <TableCell align="left">Quantity</TableCell>
                      {/* <TableCell align="left">Balance After Update</TableCell> */}
                      <TableCell align="left">Previous Stock</TableCell>
                      <TableCell align="left">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {stockHistoryData?.results?.length > 0 ? (
                      stockHistoryData?.results?.map((row) => (
                        <TableRow
                          key={row.name}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          className="dashboardTableBody"
                        >
                          <TableCell component="th" scope="row">
                            {row.date}
                          </TableCell>
                          <TableCell align="left">
                            <span className="productImg">
                              <img src={row.product_image ?? placeholderImg} />
                            </span>
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.product_name}
                          </TableCell>

                          <TableCell
                            align="left"
                            sx={{
                              color:
                                row.type === "received"
                                  ? "#2e7d32 !important"
                                  : row.type === "sold"
                                    ? "#c62828 !important"
                                    : "#6b7280 !important",
                              fontWeight: 600,
                            }}
                          >
                            {row.type ?? "---"}
                          </TableCell>

                          <TableCell align="left">{row.qty ?? "---"}</TableCell>
                          <TableCell align="left">
                            {row.previous_stock}
                          </TableCell>
                          {/* Actions */}
                          <TableCell align="left">
                            {row.type === "sold" ? (
                              <span>--</span>
                            ) : (
                              <div className="d-flex gap-3">
                                <span
                                  onClick={() =>
                                    handleInstockEditShow(row.id, row.qty)
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <FiEdit />
                                </span>
                                <span
                                  onClick={() =>
                                    handleDeleteStockHistoryShow(row.id)
                                  }
                                >
                                  <AiOutlineDelete />
                                </span>
                              </div>
                            )}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={6}
                          align="center"
                          style={{ padding: "20px" }}
                        >
                          Data not available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={historyTotalCount}
                page={historyPage}
                onPageChange={(event, newPage) => setHistoryPage(newPage)}
                rowsPerPage={historyRowsPerPage}
                onRowsPerPageChange={handleHistoryRowsPerPage}
                rowsPerPageOptions={[5, 10, 20, 50]}
              />
            </div>
          )}

          {/* Ref wise table */}

          <div className="d-flex justify-content-between">
            <div className="titleOrderList">Added Stock</div>
            <div>
              <input
                type="date"
                className="dateInput"
                value={refDateFilter}
                onChange={(e) => setRefDateFilter(e.target.value)}
              />
            </div>
            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Select Date"
                        // value={date}
                        // onChange={(newValue) => setDate(newValue)}
                        slotProps={{
                          textField: {
                            size: "small", //reduces height
                            sx: {
                              width: 160,
                              "& .MuiInputBase-root": {
                                height: 36,
                                fontSize: "13px",
                              },
                            },
                          },
                        }}
                      />
                    </LocalizationProvider> */}
          </div>

          {refDateFilter && (
            <div className="filterResultsContainer">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of:
                </span>

                {refDateFilter && (
                  <>
                    {" "}
                    &nbsp; <strong>Date:</strong> {refDateFilter}{" "}
                  </>
                )}
              </div>

              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearRefFilters}
              >
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )}

          <div className="dashboardTableContainer">
            <TableContainer component={Paper}>
              <Table
                // sx={{ minWidth: 650 }}

                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell align="left">Reference No.</TableCell>
                    <TableCell align="left">Date</TableCell>

                    <TableCell align="left">Qty Received</TableCell>
                    <TableCell align="left">Stock Value</TableCell>

                    <TableCell align="left">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {refTableData?.results?.length > 0 ? (
                    refTableData?.results?.map((row) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        className="dashboardTableBody"
                      >
                        <TableCell>{row.reference_no}</TableCell>
                        <TableCell>{row.received_date}</TableCell>
                        <TableCell>{row.qty}</TableCell>
                        <TableCell>{row.stock_value}</TableCell>

                        {/* Actions */}
                        <TableCell align="left">
                          <div className="d-flex gap-3">
                            {/* <span
                                      onClick={() =>
                                        navigate("/state-inventory-view", {
                                          state: {
                                            Id: row.id,
                                            productCode: row.product_code,
                                          },
                                        })
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      <IoEyeOutline />
                                    </span> */}

                            <span
                              onClick={() =>
                                navigate("/sub-edit-refwise-stock", {
                                  state: {
                                    Id: row.id,
                                  },
                                })
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <FiEdit />
                            </span>
                            <span onClick={() => handleDeleteStockShow(row.id)}>
                              <AiOutlineDelete />
                            </span>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        {loading ? "Loading..." : "Data Not Available"}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={refTableTotalCount}
              page={refTablePage}
              onPageChange={(event, newPage) => {
                setRefTablePage(newPage);
                sessionStorage.setItem("sub_ref_page", newPage);
              }}
              rowsPerPage={refTableRowsPerPage}
              onRowsPerPageChange={handleRefTableRowsPerPage}
              rowsPerPageOptions={[5, 10, 20, 50]}
            />
          </div>

          {/* reorder modal  */}
          <div>
            <Modal
              show={reordershow}
              onHide={handleReorderClose}
              centered
              size="xl"
              className="addModal"
            >
              <Modal.Header closeButton>
                <Modal.Title className="addModalTitle">
                  Re-Order Stock
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="addModalGrid">
                  <div>
                    <label>Reference No.</label>
                    <input
                      type="text"
                      placeholder="Enter Reference No."
                      value={refNo}
                      onChange={(e) => setRefNo(e.target.value)}
                    />
                  </div>
                  <div>
                    <label>Received Date</label>
                    <input
                      type="date"
                      onChange={(e) => setReceivedData(e.target.value)}
                      value={receivedData}
                    />
                  </div>
                </div>
                <div className="addModalGrid">
                  <div>
                    <label>Payment Type</label>
                    <select onChange={(e) => setPaymentType(e.target.value)}>
                      <option value={""} disabled selected>
                        Select
                      </option>
                      <option value="debit">Debit</option>
                      <option value="credit">Credit</option>
                    </select>
                  </div>
                  <div>
                    <label>Payment Mode</label>
                    <select onChange={(e) => setPaymentMode(e.target.value)}>
                      <option value={""} disabled selected>
                        Select
                      </option>
                      <option value="upi">UPI</option>
                      <option value="cash">Cash</option>
                    </select>
                  </div>
                </div>
                <div className="dashboardTableContainer">
                  <TableContainer component={Paper}>
                    <Table
                      // sx={{ minWidth: 650 }}
                      stickyHeader
                      aria-label="sticky table"
                    >
                      <TableHead className="dashboadTableHeader">
                        <TableRow>
                          <TableCell>Product Code</TableCell>
                          <TableCell align="left">Product Name</TableCell>
                          <TableCell align="left">Category</TableCell>
                          <TableCell align="left">UOM</TableCell>
                          <TableCell align="left">Current Stock</TableCell>
                          <TableCell align="left">
                            Default Cost Price/Unit
                          </TableCell>

                          <TableCell align="left">Qty</TableCell>
                          <TableCell align="left">Total Price</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {productDetails &&
                        Object.keys(productDetails).length > 0 ? (
                          <TableRow
                            key={productDetails.id}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                            className="dashboardTableBody"
                          >
                            <TableCell align="left">
                              {productDetails.product_code}
                            </TableCell>
                            <TableCell align="left">
                              {productDetails.product_name}
                            </TableCell>
                            <TableCell align="left">
                              {productDetails.category}
                            </TableCell>
                            <TableCell align="left">
                              {productDetails.uom}
                            </TableCell>
                            <TableCell align="left">
                              {productDetails.current_stock}
                            </TableCell>
                            <TableCell>
                              {productDetails.default_cost_price}
                            </TableCell>
                            <TableCell align="left">
                              <span className="addModalQtyInput">
                                <input
                                  type="text"
                                  value={qty}
                                  placeholder="Qty"
                                  onChange={(e) =>
                                    handleQtyChange(
                                      e.target.value,
                                      productDetails.default_cost_price,
                                    )
                                  }
                                />
                              </span>
                            </TableCell>

                            <TableCell align="left">{total}</TableCell>
                          </TableRow>
                        ) : (
                          <TableRow>
                            <TableCell align="center" colSpan={7}>
                              No product details found
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>

                <div className="addModalTotalContainer">
                  <div>
                    <div className="addModalContent">
                      <span>Total Requested Qty:</span>
                      <span>{qty}</span>
                    </div>
                    <div className="addModalContent">
                      <span>Total Price:</span>
                      <span>{total}</span>
                    </div>
                  </div>
                </div>

                <div className="addModalTextGrid">
                  <div>
                    <label>Additional Notes</label>
                  </div>
                  <div>
                    <textarea placeholder="Type here" rows={4}></textarea>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button className="addBtnCancel" onClick={handleReorderClose}>
                  Cancel
                </button>
                <button className="addBtnSave" onClick={handleSave}>
                  {" "}
                  Make Payment
                </button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
        {/* add product modal  */}
        <div>
          <Modal
            show={addshow}
            onHide={handleAddClose}
            centered
            size="lg"
            className="addModal"
          >
            <form onSubmit={formik.handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title className="addModalTitle">
                  Add New Product
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="addModalGrid">
                  <div>
                    <label>Product Code</label>
                    {/* <input
                      type="text"
                      placeholder="Enter Product Code"
                      name="product_code"
                      value={formik.values.product_code}
                      onChange={formik.handleChange}
                    /> */}
                    <select
                      onChange={formik.handleChange}
                      name="product_code"
                      value={formik.values.product_code}
                    >
                      <option value="" selected disabled>
                        Select
                      </option>

                      {dropdownProductcode?.length > 0 ? (
                        dropdownProductcode?.map((pro) => (
                          <option value={pro.product_code}>
                            {pro.product_code}
                          </option>
                        ))
                      ) : (
                        <option disabled>Data not available</option>
                      )}
                    </select>
                  </div>
                  <div>
                    <label>Min Stock Level</label>
                    <input
                      type="number"
                      placeholder="Enter min stock level"
                      name="min_stock_level"
                      value={formik.values.min_stock_level}
                      onChange={formik.handleChange}
                    />
                  </div>
                </div>

                <div className="addModalGrid">
                  <div>
                    <label>Default Cost Price (₹)</label>
                    <input
                      type="number"
                      placeholder="Enter Price"
                      name="default_cost_price"
                      value={formik.values.default_cost_price}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.default_cost_price &&
                      formik.touched.default_cost_price && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.default_cost_price}
                        </div>
                      )}
                  </div>
                  <div>
                    <label>Retail Selling Price</label>
                    <input
                      type="number"
                      placeholder="Enter Selling Price"
                      name="retail_selling_price"
                      value={formik.values.retail_selling_price}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.retail_selling_price &&
                      formik.touched.retail_selling_price && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.retail_selling_price}
                        </div>
                      )}
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="addBtnCancel"
                  type="button"
                  onClick={handleAddClose}
                >
                  Cancel
                </button>
                <button className="addBtnSave" type="submit">
                  {" "}
                  Save Product
                </button>
              </Modal.Footer>
            </form>
          </Modal>
        </div>

        {/* ref wise table delete modal  */}
        <Modal
          show={deleteStockshow}
          onHide={handleDeleteStockClose}
          centered
          className="paymentModal"
        >
          <Modal.Header closeButton style={{ borderBottom: "none" }}>
            {/* <Modal.Title>Cancel Order</Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            <div className="cancelOrderTitle">
              Are you sure want to delete stock?
            </div>

            <div className="cancelOrderBtnContainer">
              <div className="paymentBtnCancel">
                <button onClick={handleDeleteStockClose} type="button">
                  Close
                </button>
              </div>
              <div className="paymentBtnConfirm">
                <button onClick={handleDeleteRefStock}>Delete</button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* stock history delete modal  */}
        <Modal
          show={deleteStockHistoryshow}
          onHide={handleDeleteStockHistoryClose}
          centered
          className="paymentModal"
        >
          <Modal.Header closeButton style={{ borderBottom: "none" }}>
            {/* <Modal.Title>Cancel Order</Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            <div className="cancelOrderTitle">
              Are you sure want to delete stock?
            </div>

            <div className="cancelOrderBtnContainer">
              <div className="paymentBtnCancel">
                <button onClick={handleDeleteStockHistoryClose} type="button">
                  Close
                </button>
              </div>
              <div className="paymentBtnConfirm">
                <button onClick={handleDeleteStockHistory}>Delete</button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* in stock history edit modal  */}
        <div>
          <Modal
            show={instockeditshow}
            onHide={handleInstockEditClose}
            centered
            className="addModal"
          >
            <Modal.Header closeButton>
              <Modal.Title className="addModalTitle">Edit Stock</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="addModalGrid">
                <div>
                  <label>Qty Received</label>
                  <input
                    type="text"
                    placeholder="Enter Qty"
                    value={instockQty}
                    onChange={(e) => setInStockQty(e.target.value)}
                  />
                </div>
                <div>{""}</div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                className="addBtnCancel"
                type="button"
                onClick={handleInstockEditClose}
              >
                Cancel
              </button>
              <button className="addBtnSave" onClick={handleInStockEdit}>
                {" "}
                Save & Edit Stock
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
};
